import select from 'dom-select';

export const GlobalHeader = (el) => {
  const ui = {
    el,
    body: select('body'),
    pageshell: select('.pageshell'),
    searchInput: select('.global-nav__search-input'),
    langForm: select('.global-nav__lang-select'),
    langSelect: select('#lang-select'),
    globalNav: select('.global-nav'),
    toggles: select.all('.nav-item', document),
  };

  // console.log(ui);

  const searchInputToggle = () => {
    ui.searchInput.addEventListener('focus', function(e) {
      // console.log('search is focused!');
      ui.globalNav.classList.add('search-active');
    })
    ui.searchInput.addEventListener('blur', function(e) {
      // console.log('search is blurred!');
      ui.globalNav.classList.remove('search-active');
    })
  }
  
  const closeAllToggles = () => {
    ui.toggles.forEach((toggle) => {
    toggle.removeAttribute('aria-expanded');
    });
  }

  const handleLangSelect = () => {
    ui.langSelect.addEventListener('change', () => {
      // const actionURL = ui.langSelect.value;
      ui.langForm.submit();
    })
  }

  const handleBodyScroll = () => {
    let lastScrollTop = 0;

    window.addEventListener("scroll", function(){ 
      let st = window.pageYOffset || document.documentElement.scrollTop; 
      if (st > lastScrollTop){
        // down scroll code
        if (st > 100) {
          ui.pageshell.classList.add('scrolled-down');
          ui.pageshell.classList.remove('scrolled-up');
          closeAllToggles();
        }
      } else {
         // up scroll code
        ui.pageshell.classList.add('scrolled-up');
        ui.pageshell.classList.remove('scrolled-down');

        if (st === 0) {
          ui.pageshell.classList.remove('scrolled-down');
          ui.pageshell.classList.remove('scrolled-up');
        }
      }
      // For Mobile or negative scrolling
      lastScrollTop = st <= 0 ? 0 : st;
    }, 
    false
    );
  }

  const addEvents = () => {
    handleBodyScroll();
    handleLangSelect();
    searchInputToggle();
  };

  const init = () => {
    addEvents();
  };

  init();
};

export default GlobalHeader;
